module.exports = __webpack_public_path__ + "img/appstore.40a4c122.png";